import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import PageContainer from 'pages/MyAccount/shared-components/PageContainer/PageContainer';
import styles from './MyAccountNav.module.css';

const MyAccountNav = () => {
  let { url } = useRouteMatch();
  url = url.replace(/\/$/, '');
  const flags = useFlags();
  const { myAccountOrderHistory: myAccountOrderHistoryFF, rateAndReview: rateAndReviewFF } = flags;
  const ordersPathname = myAccountOrderHistoryFF ? 'orders' : 'invoice-history';

  return (
    <div className={styles.navContainer}>
      <PageContainer>
        <div className={styles.nav}>
          <NavLink
            to={url}
            className={styles.tab}
            activeClassName={styles.active}
            exact
          >
            Account Details
          </NavLink>
          <NavLink
            to={`${url}/${ordersPathname}`}
            className={styles.tab}
            activeClassName={styles.active}
          >
            {myAccountOrderHistoryFF ? 'Orders' : 'Invoice History'}
          </NavLink>
          {rateAndReviewFF && (
            <NavLink
              data-testid="rate-and-review-tab"
              to={`${url}/rate-and-review`}
              className={styles.tab}
              activeClassName={styles.active}
            >
              Rate & Review
            </NavLink>
          )}
          <NavLink
            to={`${url}/personal-survey`}
            className={styles.tab}
            activeClassName={styles.active}
          >
            Personal Survey
          </NavLink>
        </div>
      </PageContainer>
    </div>
  );
};

export default MyAccountNav;
